<!-- Con panel (tablas que lo activan) el embudo se queda aquí, sobre la tabla, y abre el panel de filtros; sin panel,
     la lista clásica con «Aplicar» de siempre -->
<button mat-icon-button [matMenuTriggerFor]="propsMenu" class="embudo"
        [matTooltip]="panelFiltros ? 'Filtros' : 'Añadir filtro'"
        (menuOpened)="panelFiltros && panelAbierto.emit()"
        *ngIf="panelFiltros ? panelFiltros.length > 0 : filtrableProperties.length > 0">
    <mat-icon fontSet="material-icons-outlined" [color]="withFilters ? 'warn' : ''">filter_alt</mat-icon>
    <span class="embudo-contador" *ngIf="panelFiltros && contadorPanel > 0">{{ contadorPanel }}</span>
</button>
<div class="menu">
    <mat-menu #propsMenu="matMenu">
        <be-panel-filtros *ngIf="panelFiltros"
                          [secciones]="panelFiltros"
                          [propiedades]="properties"
                          [filtros]="filtrosPanel"
                          (cambio)="aplicarPanel($event)"
                          (click)="$event.stopPropagation()"></be-panel-filtros>
        <!-- Ocultas y no con *ngIf: este componente lee la lista con su @ViewChild estático en ngOnInit (con panel,
             vacía). Con display en línea y no [hidden], que el display:flex de sus estilos anularía; sin panel queda
             null y el DOM es el de antes -->
        <be-filter-list #filterList [style.display]="panelFiltros ? 'none' : null"
                        (click)="$event.stopPropagation()"></be-filter-list>
        <div class="botonera" [style.display]="panelFiltros ? 'none' : null">
            <button mat-flat-button color="warn"
                    (click)="clearFilters()">Resetear
            </button>
            <button mat-flat-button color="primary"
                    (click)="applyFilters()">Aplicar
            </button>
        </div>
    </mat-menu>
</div>
